"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateEmailClassifierConfigAction } from "@/server-actions/email-classifier-config"
import { emailClassifierConfigQueryKey } from "@/hooks/queries/email-classifier-config"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { useTranslations } from "next-intl"


export function useUpdateEmailClassifierConfigMutation(agentId: string | null) {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsEmailClassifierConfig")

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: { system_prompt: string; classifier_labels: string[] }) => {
      if (!agentId) throw new Error(tUi("agentIDIsRequired"))
      const result = await withQueryHandling(
        updateEmailClassifierConfigAction({ agent_id: agentId, ...input }),
        { loading: tUi("savingClassificationSettings"), success: tUi("classificationSettingsSaved") },
      )
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: async () => {
      if (agentId) {
        await queryClient.invalidateQueries({ queryKey: emailClassifierConfigQueryKey(agentId) })
      }
    },
  })
}
